import styled from 'styled-components';

import { media } from '@theme/media';
import { COLORS } from '@theme/colors';

export const ErrorContainer = styled.div`
  min-height: var(--vh);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  line-height: normal;
  text-align: center;
  max-width: 1000px;
  margin: 0 auto;

  > h1 {
    font-weight: normal;
    font-size: 18px;

    ${media.tablet} {
      font-size: 26px;
    }
  }
`;

export const ErrorNumber = styled.div`
  font-size: 40px;

  ${media.tablet} {
    font-size: 50px;
  }
`;

export const LinkArrow = styled.span`
  &:before {
    content: '\\2192';
    font-size: 0.8em;
    margin-right: 2px;
  }
`;

export const TextMessage = styled.div`
  margin: 17px 0;

  ${media.mobile} {
    margin: 14px 0;
  }
`;

export const LineTitle = styled.div`
  border-bottom: 1px solid ${COLORS.BLACK};
  margin-bottom: 34px;
  text-align: ${({ isLeft = false }: { isLeft?: boolean }) => (isLeft ? 'left' : 'center')};
  padding-top: 9px;
  padding-bottom: 6px;
  font-size: 14px;
  text-transform: uppercase;

  ${media.mobile} {
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0.02em;
  }
`;

export const LineContainer = styled.div`
  border-top: 1px solid ${COLORS.BLACK};
`;

export const EmailLink = styled.a`
  color: ${COLORS.BLACK};
  border-bottom: 1px solid ${COLORS.BLACK40};
`;

export const FocusTrap = styled.div.attrs({ tabIndex: 0 })`
  position: absolute;
  opacity: 0;
`;
